<form [formGroup]="formGroup" id="goalsForm">
  <h5 class="mb-4">
    {{ "whichGoalsArePriorityForYou" | translate }}
  </h5>

  <div class="table-responsive">
    <table class="table table-row-bordered table-row-gray-100">
      <thead>
        <tr class="fw-bold fs-6 text-gray-800">
          <th></th>
          <th class="text-center">
            {{ "veryHighPriority" | translate }}
          </th>
          <th class="text-center">
            {{ "highPriority" | translate }}
          </th>
          <th class="text-center">
            {{ "secondaryPriority" | translate }}
          </th>
          <th class="text-center">
            {{ "notImportant" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let goal of goalQuestions">
          <tr>
            <td class="fw-bold">{{ goal.text }}</td>
            <td class="text-center">
              <div
                class="form-check form-check-custom form-check-solid d-flex justify-content-center"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="goal.controlName"
                  [value]="priorityLevels[0].value"
                  [id]="goal.id + 'VeryHigh'"
                />
              </div>
            </td>
            <td class="text-center">
              <div
                class="form-check form-check-custom form-check-solid d-flex justify-content-center"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="goal.controlName"
                  [value]="priorityLevels[1].value"
                  [id]="goal.id + 'High'"
                />
              </div>
            </td>
            <td class="text-center">
              <div
                class="form-check form-check-custom form-check-solid d-flex justify-content-center"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="goal.controlName"
                  [value]="priorityLevels[2].value"
                  [id]="goal.id + 'Medium'"
                />
              </div>
            </td>
            <td class="text-center">
              <div
                class="form-check form-check-custom form-check-solid d-flex justify-content-center"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="goal.controlName"
                  [value]="priorityLevels[3].value"
                  [id]="goal.id + 'Low'"
                />
              </div>
            </td>
          </tr>
          <div *ngIf="isControlInvalid(goal.controlName)" class="text-danger">
            {{ "selectionRequired" | translate }}
          </div>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Next Step Button -->
  <div class="text-end mt-5">
    <button
      (click)="goToNextStep()"
      type="submit"
      class="btn btn-sm btn-primary cursor-pointer"
    >
      {{ "nextStep" | translate }}
    </button>
  </div>
</form>
